import React, { useState } from 'react';
import { NotificationManager } from "react-notifications";
import resetPasswordResponse from '../../apis/password/resestPassword';
import { validatePassword, validatePasswordMatch, passwordValidationMsg, passwordMismatchMsg } from '../../utilities/validations';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import './resetpassword.css';

const PasswordReset = ({ email, onPasswordReset }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [newPasswordTouched, setNewPasswordTouched] = useState(false);
  const [confirmPasswordTouched, setConfirmPasswordTouched] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isNewPasswordValid = validatePassword(newPassword) && newPassword.length > 0;
  const isConfirmPasswordValid = validatePasswordMatch(newPassword, confirmPassword) && confirmPassword.length > 0;

  const handleNewPasswordChange = (value) => {
    setNewPassword(value);
    setNewPasswordTouched(true);
  };

  const handleConfirmPasswordChange = (value) => {
    setConfirmPassword(value);
    setConfirmPasswordTouched(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const payloadData = {
      email: email,
      newpassword: newPassword,
    };
    
    setIsLoading(true);
    
    try {
      const resetPasswordReqData = await resetPasswordResponse(payloadData);
      
      if (resetPasswordReqData.data.message.includes('Password Updated succerssfully')) {
        NotificationManager.success("Password Updated", "Success", 10000);
        
        if (onPasswordReset) {
          onPasswordReset();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="login_wrapper_main">
        <div className='login_container login-box-border reset-password-modern'>
          <div className='candidate-signin-title'>
            <p className='fs-semi-bold fs-22'>Create New Password</p>
            <p className='reset-subtitle'>Please enter your new password below</p>
          </div>
          
          <div className='reset-password-content'>
            <div className='form-group-reset'>
              <label className="field_name_reset" htmlFor="newPassword">
                New Password
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showNewPassword ? "text" : "password"}
                  id="newPassword"
                  name="newPassword"
                  className='password-input-reset password-input-no-reveal'
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => handleNewPasswordChange(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="password-eye-btn"
                  onClick={() => setShowNewPassword((prev) => !prev)}
                  aria-label={showNewPassword ? "Hide password" : "Show password"}
                >
                  {showNewPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </button>
              </div>
              <p className='password-hint'>{passwordValidationMsg}</p>
              
              {newPasswordTouched && !isNewPasswordValid && newPassword && (
                <p className='form-error-reset'>{passwordValidationMsg}</p>
              )}
            </div>
            
            <div className="form-group-reset mt_20">
              <label className="field_name_reset" htmlFor="confirmPassword">
                Confirm Password
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  className='password-input-reset password-input-no-reveal'
                  placeholder="Re-enter new password"
                  value={confirmPassword}
                  onChange={(e) => handleConfirmPasswordChange(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="password-eye-btn"
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                >
                  {showConfirmPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </button>
              </div>
              
              {confirmPasswordTouched && !isConfirmPasswordValid && confirmPassword && (
                <p className='form-error-reset'>{passwordMismatchMsg}</p>
              )}
            </div>
            
            <div className='reset-password-btn-container'>
              <button
                type="submit"
                className='btn-reset-password-modern'
                disabled={!isNewPasswordValid || !isConfirmPasswordValid || isLoading}
              >
                {isLoading ? 'Resetting...' : 'Reset Password'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default PasswordReset;
